import { render, staticRenderFns } from "./BaseMitLoading.vue?vue&type=template&id=edcdda82&scoped=true"
import script from "./BaseMitLoading.vue?vue&type=script&lang=js"
export * from "./BaseMitLoading.vue?vue&type=script&lang=js"
import style0 from "./BaseMitLoading.vue?vue&type=style&index=0&id=edcdda82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edcdda82",
  null
  
)

export default component.exports